import { authorizedInstance } from "../config/axios"
import { buildQueryString } from "../utils"

export const getOrderDeliverySummary = async ({ filters = {} } = {}) => {
  const query = buildQueryString({ ...filters })
  const response = await authorizedInstance.get(
    `/order-delivery-insights/summary?${query}`
  )
  return response.data
}

export const getMissingOrmList = async ({
  page = 1,
  limit = 25,
  filters = {},
} = {}) => {
  const query = buildQueryString({ page, limit, ...filters })
  const response = await authorizedInstance.get(
    `/order-delivery-insights/missing-orm?${query}`
  )
  return response.data
}

export const getUndeliveredList = async ({
  page = 1,
  limit = 25,
  filters = {},
} = {}) => {
  const query = buildQueryString({ page, limit, ...filters })
  const response = await authorizedInstance.get(
    `/order-delivery-insights/undelivered?${query}`
  )
  return response.data
}

export const getReroutedList = async ({
  page = 1,
  limit = 25,
  filters = {},
} = {}) => {
  const query = buildQueryString({ page, limit, ...filters })
  const response = await authorizedInstance.get(
    `/order-delivery-insights/rerouted?${query}`
  )
  return response.data
}

export const getStudyDetail = async ({ accessionNo, issuer }) => {
  const query = buildQueryString({ accessionNo, issuer })
  const response = await authorizedInstance.get(
    `/order-delivery-insights/detail?${query}`
  )
  return response.data
}
